<template>
  <base-edit-form
    :edit-form="editForm"
    :formTitle="formTitle"
    @submitForm="submitForm"
    @cancel="cancel"
  ></base-edit-form>
</template>

<script>
import { BaseEditForm } from "@/components/Base/index.js";
import sanitizer from "sanitizer";
import { CriterionService } from "../../../services/criterion.service";
import formatDateTime from "@/core/utils/formatTime";
import { CriterionCategoriesService } from "../../../services/criterionCategories.service";

export default {
  name: "CriterionEditForm",
  components: { BaseEditForm },
  data() {
    return {
      params: {
        name: null,
        description: null,
        weight: null,
        benchmark: null,
        criterion_category_id: null,
        default_value: null
      },
      formTitle: this.$t("page_title.criterion_edit"),
      editForm: [
        {
          label: this.$t("criterion.name"),
          name: "name",
          value: "",
          type: "input",
          required: true,
          validateRule: "required"
        },
        {
          label: this.$t("criterion.category_name"),
          name: "criterion_category_id",
          value: "",
          type: "select",
          options: [],
          required: true,
          validateRule: "required"
        },
        {
          label: this.$t("criterion.description"),
          name: "description",
          value: "",
          type: "textarea",
          required: false,
          validateRule: ""
        }
      ]
    };
  },
  methods: {
    cancel() {
      this.$router.push({ name: "CriterionList" });
    },
    async submitForm(params) {
      const response = await new CriterionService().update(
        this.$route.params.id,
        params
      );
      if (!response) return;
      this.$notify({
        title: this.$t("common.updated"),
        text: this.$t("common.updated_text", {
          value: sanitizer.escape(response.name),
          name: this.$t("criterion.title")
        }),
        type: "success"
      });
    },
    async getDetail() {
      let info = await new CriterionService().getById(this.$route.params.id);
      this.params.name = this.editForm[0].value = info.name;
      this.params.criterion_category_id = this.editForm[1].value =
        info.criterion_category_id;
      this.params.description = this.editForm[2].value = info.description;
      this.params.created_by = info.created_by;
      this.params.created_at = info.created_at
        ? formatDateTime(info.created_at)
        : "";
      this.params.updated_at = info.updated_at
        ? formatDateTime(info.updated_at)
        : "";
    },
    async getCriterionCategories() {
      const response = await new CriterionCategoriesService().getList({
        limit: 1000
      });
      this.editForm[1].options = response.data || [];
      return response.data;
    }
  },
  created() {
    this.getDetail();
    this.getCriterionCategories();
  }
};
</script>

<style scoped></style>
